// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__BRMQT","social":"socials__social__cEC91","rtlSocial":"socials__rtlSocial__kG2oF","icon":"socials__icon__WSlYK","navOpen":"socials__navOpen__vbk7Q"};